import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@mode/capra';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent],
  selector: 'mode-email-settings-header',
  template: `
    <div class="subheading-container">
      <capra-icon icon="icon-email"></capra-icon>
      <h3 class="subheading" data-test="title">Email settings</h3>
    </div>
  `,
  styleUrls: ['./email-settings-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  //
}
